import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { useNavigate } from "react-router-dom";
import close from "../../../../../assets/images/x.png"
import search from "../../../../../assets/images/search-normal.png"
import check from "../../../../../assets/images/CHECKMARK.png"

const variantstorageModal = ({ show, onDeleteClick, onCloseClick } : any) => {

  interface FindModalProps {
    show: boolean;
    onCloseClick: () => void;
    activities: any
    order: any
}
  
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} className="smallModal">
      <ModalBody className="py-3 px-5">
        <div className="ColorModal">
            <div className="colorFamily">
              <h6>Storage Capacity</h6>
              <img src={close} alt="" onClick={onCloseClick} />
            </div>
            {/* <div className="border-box"></div> */}  
              <div className="input">
                  <input
                    type="text"
                    placeholder="Search"
                    data-testing-id="searchInput_PromotionListing"
                  />
                  <img src={search} alt="Search Icon" />
                </div>
                   <div className="color-tags">
            <span className="tag">128GB <span className="remove">×</span></span>
            <span className="tag">256GB <span className="remove">×</span></span>

          </div>
          <div className="color-list-container">
  <h3>Storage</h3>
  <ul className="color-list">

    <li className="color-item"><span className="color-name">32GB</span></li>
    <li className="color-item"><span className="color-name">64GB</span></li>
    <li className="color-item"><span className="color-name">128GB</span></li>
    <li className="color-item selected">
      <span className="color-name">128GB</span>
      <span className="checkmark"><img src={check} alt="" /></span>
      
    </li> 
        <li className="color-item selected">
      <span className="color-name">256GB</span>
      <span className="checkmark"><img src={check} alt="" /></span>
      
    </li> 
     
      <li className="color-item"><span className="color-name">1TB</span></li>
    <li className="color-item"><span className="color-name">512BG</span></li>

    <li className="color-item"><span className="color-name">2TB</span></li>

  </ul>

</div>
  <div className="Savebutton">
    <button>Save</button>
  </div>

        </div>
      </ModalBody>
    </Modal>
  );
};

variantstorageModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
};

export default variantstorageModal;